export const RESPONSES_GET_STATUS = Object.freeze({
	SUCCESS: '0000',
	IN_PROGRESS: '0001',
	ERROR: '0002',
	NOT_STARTED: '0003',
});
